
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 1.333a6.667 6.667 0 100 13.334A6.667 6.667 0 008 1.333zm0 1a5.667 5.667 0 110 11.335A5.667 5.667 0 018 2.333zM5.984 6.637a.5.5 0 00-.652.754l2.314 2.324.056.049a.5.5 0 00.652-.049l2.314-2.324.049-.056a.5.5 0 00-.05-.65l-.056-.05a.5.5 0 00-.651.05L8 8.654 6.04 6.686l-.056-.049z","fill":"#fff"}})])
          )
        }
      }
    